import React, { useRef, useCallback, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import api from '../../services/api';

import getValidationErrors from '../../utils/getValidationErrors';

import AuthInput from '../../components/AuthInput';
import Modal from '../../components/Modal';
import Loader from '../../components/Loader';

import Logo from '../../assets/image 6.svg';

import { Container, Form } from './styles';

const ForgetPassword = () => {
  const [toggleModal, setToggleModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [updateLoading, setUpdateLoading] = useState(false);
  const firstFormRef = useRef(null);
  const secondFormRef = useRef(null);
  const history = useHistory();

  const handleSubmit = useCallback(async (data) => {
    try {
      firstFormRef.current?.setErrors({});

      const schema = Yup.object().shape({
        email: Yup.string('E-mail inválido').required('Email neceśsário'),
      });
      await schema.validate(data, { abortEarly: false });
      setLoading(true);
      await api.post('/forgot', data);
      localStorage.setItem('@Ocariot:userEmail', data.email);
      setLoading(false);
      setToggleModal(true);
      toast.success('Email enviado');
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err)
        firstFormRef.current?.setErrors(errors);
        return;
      }
      setLoading(false);
      toast.error('Usuário ou senha inválidos. Por favor tente novamente');
    }
  }, []);

  const changePassword = useCallback(async (data) => {
    try {
      secondFormRef.current?.setErrors({});
      const email = localStorage.getItem('@Ocariot:userEmail');
      const schema = Yup.object().shape({
        code: Yup.string().required('Código neceśsário'),
        password: Yup.string().required('Senha neceśsária'),
        confirmPassword: Yup.string().required('Confirmação neceśsária'),
      });

      await schema.validate(data, { abortEarly: false });
      setUpdateLoading(true)
      await api.put('/forgot/update', {
        email,
        token: data.code,
        newPassword: data.password
      })
      setUpdateLoading(false)
      toast.success('Senha alterada com sucesso!');

      history.push('/')

    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err)
        secondFormRef.current?.setErrors(errors);
        return;
      }
      setUpdateLoading(false)
      toast.error('Código inválido. Por favor tente novamnete');
    }
  }, [history]);


  return (
    <>
      <Modal title="Alteração de senha" show={toggleModal} onClose={() => setToggleModal(false)}>
        <Form ref={secondFormRef} onSubmit={changePassword}>
          <p className="modal-paragraph">Você solicitou uma alteração de senha. Por favor preencha os campos a baixo.</p>
          <AuthInput type="text" name="code" placeholder="Código" />
          <AuthInput name="password" placeholder="Senha" icon={true} />
          <AuthInput name="confirmPassword" placeholder="Confirmar Senha" icon={true} />
          <button type="submit">{updateLoading ? <Loader color='white' /> : 'Confirmar'}</button>
        </Form>

      </Modal>
      <Container>
        <Form ref={firstFormRef} onSubmit={handleSubmit}>
          <img src={Logo} alt="Ocariot" />
          <h2>Esqueceu a senha?</h2>
          <p>
            Por favor nos informe o seu e-mail para que possamos enviar
            instruções para a sua alteração de senha.
          </p>
          <AuthInput type="text" name="email" placeholder="E-mail" />
          <Link to="/">
            <FaArrowLeft />
            <span>Voltar para Login</span>
          </Link>
          <button type="submit">{loading ? <Loader color='white' /> : 'Confirmar'}</button>

        </Form>

      </Container>
    </>
  );
}

export default ForgetPassword;